import { FORBIDDEN_GA4_PARAMS } from './taxonomy';
import type { GA4EventParams } from './types';

export function sanitizeGA4Params(params: GA4EventParams): GA4EventParams {
  const result: GA4EventParams = {};

  for (const [key, value] of Object.entries(params)) {
    if (FORBIDDEN_GA4_PARAMS.has(key)) {
      continue;
    }
    if (typeof value === 'string' && value.includes('@')) {
      continue;
    }
    result[key] = value;
  }

  return result;
}

export function sanitizePagePath(path: string): string {
  const pathname = path.split(/[?#]/, 1)[0] || '/';

  return pathname
    .replace(/\/occasions\/[^/]+/g, '/occasions/:id')
    .replace(/\/events\/[^/]+/g, '/events/:id')
    .replace(/\/actors\/[^/]+/g, '/actors/:id')
    .replace(/\/guests\/[^/]+/g, '/guests/:id')
    .replace(/\/households\/[^/]+/g, '/households/:id')
    .replace(/\/vendors\/[^/]+/g, '/vendors/:id')
    .replace(/\/forms\/[^/]+/g, '/forms/:id')
    .replace(/\/submissions\/[^/]+/g, '/submissions/:id')
    .replace(/\/assets\/[^/]+/g, '/assets/:id')
    .replace(/\/documents\/[^/]+/g, '/documents/:id')
    .replace(/\/campaigns\/[^/]+/g, '/campaigns/:id')
    .replace(/\/invitations\/[^/]+/g, '/invitations/:id')
    .replace(/\/distributions\/[^/]+/g, '/distributions/:id')
    .replace(/\/sessions\/[^/]+/g, '/sessions/:id')
    .replace(/\/tokens\/[^/]+/g, '/tokens/:token');
}

export function mapRouteToPageType(path: string): string {
  if (path.includes('/timeline')) return 'timeline_detail';
  if (path.includes('/seating')) return 'seating_detail';
  if (path.includes('/gallery')) return 'gallery_view';
  if (path.includes('/rsvp')) return 'rsvp_flow';
  if (path.includes('/occasions') && path.includes('/events'))
    return 'event_detail';
  if (path.includes('/occasions')) return 'occasion_detail';
  if (path.includes('/vendors')) return 'vendor_portal';
  if (path.includes('/guests')) return 'guest_portal';
  if (path.includes('/admin')) return 'admin_panel';
  if (path.includes('/dashboard')) return 'dashboard';
  if (path.includes('/docs')) return 'docs';
  if (path === '/') return 'home';
  return 'unknown';
}
